import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../../src/styles/userManagement.css";
import AllBIA from "./AllBIA";
import AllRISK from "./AllRisk";
import CreateRisk from "./createRisk";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import useHttp from "../../../../hooks/useHttp"
import APIService from "../../../../services/apiAxiosService";
function RiskAssessment() {
  const [currentTab, setCurrentTab] = useState(0);
  const [reset, setReset] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [classifications, setClassifications] = useState([]);
  const [businesssAnalysis, setBusinesssAnalysis] = useState([]);
  const [businesssReviewData, setBusinesssReviewData] = useState([]);
  const [businessUsers, setBusinessUsers] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const { sendRequest: getriskvendorlist} = useHttp();
  const { sendRequest: getAllBUUsersList } = useHttp();
  const { sendRequest: getAllPriorityLevels } = useHttp();
  const { sendRequest: getAllClassifications } = useHttp();
  const { sendRequest: getBIAReviewData } = useHttp();
  const { sendRequest: getAllRiskData } = useHttp();
  const { sendRequest: deleteRiskRequestByID } = useHttp();
  const ChangeTab = (id) => {
    setCurrentTab(id);
  };
  const handleTabs = (v) => {
    setCurrentTab(v);
    setReset(!reset);
  };
  const handleDelete = async (AnalysisId, setDeletemodalVisible ) => {
    setLoading(true);
    try {
      deleteRiskRequestByID(APIService.deleteRiskRequestByID(AnalysisId), (result) => {
        if (result.CODE) {
          setDeletemodalVisible(false)
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getBusinessListData();
        } else {
          setDeletemodalVisible(false)
          setLoading(false);
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };
 
  const getBusinessListData = async () => {
    getAllRiskData(APIService.getAllRiskData(), (data) => {
      data.MSG.forEach(function (a) {
        a.expiray_date = a.expiray_date.substring(0, 10);
        a.date_issued = a.date_issued.substring(0, 10);
      });
      setBusinesssAnalysis(data.MSG);
    })
  };
  const getBIAReview = async () => {
    getBIAReviewData(APIService.getBIAReviewData(), (data) => {
      data.MSG.forEach(function (a) {
        a.expiray_date = a.expiray_date.substring(0, 10);
        a.date_issued = a.date_issued.substring(0, 10);
      });
      setBusinesssReviewData(data.MSG);
    })
  };
  const getAllVendorListData = async () => {
    getriskvendorlist(APIService.getriskvendorlist(), (data) => {
      setVendors(data.MSG);
    })
  };
  const getAllClassificationsData = async () => {
    getAllClassifications(APIService.getAllClassifications(), (data) => {
      setClassifications(data.MSG);
    })
  };
  const getAllBUUsers = async () => {
    getAllBUUsersList(APIService.getAllBUUsersList(), (data) => {
      setBusinessUsers(data.MSG);
    })

  };
  const getAllPriorityList = async () => {
    getAllPriorityLevels(APIService.getAllPriorityLevels(), (data) => {
      setPriorityList(data.MSG);
    })
  };
  useEffect(() => {
    getAllVendorListData();
    getAllClassificationsData();
    getBusinessListData();
    getBIAReview();
    getAllBUUsers();
    getAllPriorityList();
  }, []);
  return (
    <div className="user-management-container">
      <Tabs
        activeIndex={currentTab}
        onTabChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="view-risk-requests" label="View Risk Requests">
          <AllRISK
            reload={getBusinessListData}
            loading={loading}
            BusinesssAnalysis={businesssAnalysis}
            vendors={vendors}
            classifications={classifications}
            businessUsers={businessUsers}
          />
        </Tab>
        <Tab value="create-risks" label="Create Risks">
          <CreateRisk
            SetTab={setCurrentTab}
            reload={getBusinessListData}
            vendors={vendors}
            classifications={classifications}
            businessUsers={businessUsers}
            priorityList={priorityList}
          />
        </Tab>
        <Tab value="all-bia-requests" label="All BIA Requests">
          <AllBIA
            reset={reset}
            loading={loading}
            BusinesssAnalysis={businesssReviewData}
            handleDelete={handleDelete}
            getBusinessListData={getBusinessListData}
          />
        </Tab>
      </Tabs>
    </div>
  );
}
export default RiskAssessment;
